import BaseLayout from "../layout/layout-with-sider/BaseLayout";
import {Button, Card} from "antd";
import ProjectUploader from "../ProjectUploader";
import React from "react";
import ProjectList from "./ProjectList";
import {AppActions, useAppContext} from "../../Context/ProjectContextV2";
import ApiService from "../../Service/ApiService";

export default function ProjectComparerV2() {
    const {dispatchProject, appContext} = useAppContext()

    const onUploadProject = async (projects) => {
        for (const project of projects) {
            try {
                let data = project?.projectFiles?.map(prj => {
                    return {
                        projectTitle: project.information.title,
                        flowTitle: prj.flow.title,
                        planTitle: prj.plan.title,
                        geometryTitle: prj.geometry.title,
                        projectHash: prj.projectHash
                    }
                })

                const res = await ApiService.UserProject.UploadProject(data);
            }
            catch (exp) {
                console.log(exp)
            }
        }

        dispatchProject({
            type: AppActions.SET_PROJECTS,
            data: {
                projects: projects
            }
        })
    }

    return (
        <BaseLayout>
            <Card
                title={(
                    <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                        <>Upload Project</>
                    </div>
                )}
            >
                <ProjectUploader
                    onUploadProject={onUploadProject}
                />
                <br/>
                <ProjectList />
            </Card>
        </BaseLayout>
    )
}